module.exports = __webpack_public_path__ + "img/excercise.24060663.png";